"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Diligent_1 = __importDefault(require("@acl-services/wasabicons/lib/Diligent"));
var DiligentWordmark_1 = __importDefault(require("@acl-services/wasabicons/lib/DiligentWordmark"));
var l10n_1 = require("@paprika/l10n");
var panel_1 = __importDefault(require("@paprika/panel"));
var NavigationButton_1 = __importDefault(require("../NavigationButton/NavigationButton"));
var NavigationIcon_1 = __importDefault(require("../NavigationIcon/NavigationIcon"));
var AppSwitcherTitle_1 = __importDefault(require("./AppSwitcherTitle/AppSwitcherTitle"));
var OrganizationSwitcher_1 = __importDefault(require("./OrganizationSwitcher/OrganizationSwitcher"));
var AppRow_1 = __importDefault(require("./Sections/Section/AppRow"));
var Sections_1 = __importDefault(require("./Sections/Sections"));
var ThemeProvider_1 = require("../theme/ThemeProvider");
var constants_1 = require("../../constants");
var resourceData_1 = __importDefault(require("../../data/resourceData"));
var organizationShape_1 = __importDefault(require("./organizationShape"));
var availableAppShape_1 = __importDefault(require("./availableAppShape"));
var sc = __importStar(require("./AppSwitcherSidePanel.styles"));
function AppSwitcherSidePanel(_a) {
    var launchpadUrl = _a.launchpadUrl, productTitle = _a.productTitle, organizations = _a.organizations, apps = _a.apps, initialOrganizationId = _a.initialOrganizationId, resourceLinks = _a.resourceLinks, zIndex = _a.zIndex;
    var i18n = l10n_1.useI18n();
    var _b = react_1.default.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = react_1.default.useState(initialOrganizationId), activeOrganizationId = _c[0], setActiveOrganizationId = _c[1];
    var isDiligentBrand = ThemeProvider_1.useTheme().isDiligentBrand;
    var activeOrganization = organizations.find(function (organization) { return organization.id === activeOrganizationId; });
    function handleToggleSidePanel() {
        setIsOpen(function (prevIsOpen) { return !prevIsOpen; });
        setActiveOrganizationId(initialOrganizationId);
    }
    function renderResourceLinks() {
        return (react_1.default.createElement(sc.ResourceSection, { "data-sri-anchor": "app-switcher-section", "data-testid": "resource-section" }, Object.keys(resourceLinks).map(function (resourceKey) {
            var foundResource = resourceData_1.default.find(function (data) { return data.key === resourceKey; });
            return (react_1.default.createElement(AppRow_1.default, { app: __assign({ link: (activeOrganization && activeOrganization[resourceKey]) || resourceLinks[resourceKey], title: i18n.t("global_navigation.apps." + resourceKey) }, foundResource), shouldOpenNewTab: ['academy', 'community'].includes(resourceKey), key: foundResource.key }));
        })));
    }
    return (react_1.default.createElement(sc.NavigationAppSwitcher, { "data-sri-anchor": "navigation-app-switcher" },
        react_1.default.createElement(NavigationButton_1.default, { ariaLabel: i18n.t('global_navigation.navigation_items.app_switcher'), "data-sri-anchor": "navigation-item.trigger", onClick: handleToggleSidePanel, zIndex: zIndex },
            react_1.default.createElement(NavigationIcon_1.default, { icon: constants_1.icons.appSwitcher })),
        react_1.default.createElement(sc.AppSwitcherPanel, { a11yText: i18n.t('global_navigation.navigation_items.app_switcher'), "data-sri-anchor": "navigation-app-switcher.side-panel", isOpen: isOpen, onClose: handleToggleSidePanel, slideFrom: panel_1.default.types.slideFrom.LEFT, width: "350px", zIndex: zIndex },
            react_1.default.createElement(panel_1.default.FocusLock, null),
            react_1.default.createElement(panel_1.default.Overlay, { onClose: handleToggleSidePanel }),
            react_1.default.createElement(sc.PanelHeader, null,
                react_1.default.createElement(AppSwitcherTitle_1.default, { launchpadUrl: launchpadUrl, onClose: handleToggleSidePanel }, productTitle)),
            activeOrganization ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(OrganizationSwitcher_1.default, { organizations: organizations, activeOrganizationId: activeOrganizationId, zIndex: zIndex }),
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Sections_1.default, { apps: apps }),
                    renderResourceLinks()))) : (renderResourceLinks()),
            isDiligentBrand && (react_1.default.createElement(sc.AppSwitcherPanelFooter, null,
                react_1.default.createElement(sc.FooterLink, { href: "https://www.diligent.com/", rel: "noopener noreferrer", target: "_blank" },
                    react_1.default.createElement(Diligent_1.default, { className: "diligent-logo" }),
                    react_1.default.createElement(DiligentWordmark_1.default, { className: "diligent-wordmark" })))))));
}
AppSwitcherSidePanel.componentType = constants_1.navigationItems.appSwitcher;
AppSwitcherSidePanel.propTypes = {
    launchpadUrl: prop_types_1.default.string.isRequired,
    productTitle: prop_types_1.default.string,
    organizations: prop_types_1.default.arrayOf(prop_types_1.default.shape(organizationShape_1.default)).isRequired,
    apps: prop_types_1.default.arrayOf(prop_types_1.default.shape(availableAppShape_1.default)).isRequired,
    initialOrganizationId: prop_types_1.default.number,
    resourceLinks: prop_types_1.default.exact({
        launchpad: prop_types_1.default.string.isRequired,
        academy: prop_types_1.default.string.isRequired,
        community: prop_types_1.default.string.isRequired,
    }).isRequired,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
AppSwitcherSidePanel.defaultProps = {
    initialOrganizationId: null,
    productTitle: '',
    zIndex: null,
};
exports.default = AppSwitcherSidePanel;
//# sourceMappingURL=AppSwitcherSidePanel.js.map